import { FC } from 'react';
import styled from 'styled-components';

import { textColor, THEME_MUTED } from '../../styles/basics/colors';
import { useTranslation } from 'react-i18next';

export const NO_ELEMENTS_PRODUCT = 'product';
export const NO_ELEMENTS_PRODUCTS = 'products';
export const NO_ELEMENTS_PRODUCT_GROUPS = 'productGroups';
export const NO_ELEMENTS_ELEMENT = 'element';
export const NO_ELEMENTS_ELEMENTS = 'elements';
export const NO_ELEMENTS_BUNDLES = 'bundles';
export const NO_ELEMENTS_NEWLY_ADDED_PRODUCT = 'newlyAddedProduct';
export const NO_ELEMENTS_ORDERS = 'orders';
export const NO_ELEMENTS_RESERVES = 'reserves';
export const NO_ELEMENTS_REPORTS = 'reports';
export const NO_ELEMENTS_LC_TITLES = 'lcTitles';
export const NO_ELEMENTS_LC_COLLECTION_TITLES = 'lcCollectionTitles';
export const NO_ELEMENTS_LC_TITLES_FILTERED = 'lcTitlesFiltered';
export const NO_ELEMENTS_LC_AUTHORS = 'lcAuthors';
export const NO_ELEMENTS_VISITS = 'analyticsVisits';

const StNoElementsFound = styled.div.attrs({ 'data-displayname': 'NoElementsFound' })<{ margin?: number }>`
    font-size: 18px;
    ${textColor(THEME_MUTED)};
    text-align: center;
    width: 100%;
    margin-top: ${props => props.margin || 70}px;
`;

interface Props {
    type?: string;
    margin?: number;
    typeToMessage?: { [key: string]: string };
}

const NoElementsFound: FC<Props> = ({ type = 'elements', margin }) => {
    const { t } = useTranslation();
    return (
        <StNoElementsFound margin={margin} data-testid="NoElementsFound">
            {t(`typeToMessage.${type}`)}
        </StNoElementsFound>
    );
};

export default NoElementsFound;
